import { useState } from "react";
import Advanced from "./components/Advanced";

export default function Searcher({
    detalleTab,
    pageName,
    onChange,
}) {
    const [reset, setReset] = useState(false);

    const handleReset = (state) => {
        setReset(state);
        if (state) {
            onChange({});
        }
    };

    return (
        <div className="w-100 d-flex flex-wrap flex-lg-nowrap align-items-stretch justify-content-between mt-3"> 
            <Advanced 
                reset={reset}
                pageName={pageName}
                detalleTab={detalleTab}
                onChange={onChange}
                onReset={handleReset}
            />
        </div> 
    );
}